import { Component } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  selectedRequestIndex = 0;

  private readonly fieldJournalImageMap: Record<string, string> = {
    'assets/images/kari_and_roland_rr.jpg': 'assets/images/design-a/kari-roland-georgetown-field-journal.jpg',
    'assets/images/kari_roland_door.jpg': 'assets/images/design-a/kari-roland-door-field-journal.jpg',
    'assets/images/roland_bridge_standing.jpg': 'assets/images/design-a/roland-bridge-standing-field-journal.jpg',
    'assets/images/kari_bridge.jpg': 'assets/images/design-a/kari-bridge-field-journal.jpg'
  };



  serviceAreas = [
    'Georgetown',
    'Round Rock',
    'Pflugerville',
    'Hutto',
    'Cedar Park',
    'Liberty Hill',
    'Jarrell',
    'Austin',
    'Buda',
    'Kyle'
  ];

  requestDetails = [
    'Property address and access notes',
    'Inspection type or reason for reaching out',
    'Preferred date, deadline, or option-period timing',
    'Inspection questions Roland should know before arriving'
  ];

  reassurancePoints = [
    {
      title: 'Phone, text, or email works',
      description: 'Use the contact path that is easiest for you. GTX will follow up with scheduling details.'
    },
    {
      title: 'Your details stay focused',
      description: 'Contact information is used to respond to the inspection request and coordinate service.'
    },
    {
      title: 'You know the next inspection step',
      description: 'GTX confirms the request, coordinates availability, then Roland completes the inspection and report.'
    }
  ];

  contactChecklist = [
    {
      label: 'Response path',
      value: 'GTX follows up by phone, text, or email using the information in your request.'
    },
    {
      label: 'Privacy',
      value: 'Form details are used to respond to the inspection request and coordinate service.'
    },
    {
      label: 'Local team',
      value: 'Roland and Kari support Georgetown and nearby Central Texas clients directly.'
    }
  ];

  contactRouteSteps = [
    {
      title: 'Request received',
      description: 'GTX reviews the property, timing, contact details, and inspection need you send.'
    },
    {
      title: 'Scheduling confirmed',
      description: 'Kari or GTX follows up by phone, text, or email to coordinate availability and access details.'
    },
    {
      title: 'Inspection prepared',
      description: 'Roland uses the notes to understand the property question before the appointment begins.'
    }
  ];

  formRouteFacts = [
    {
      label: 'Phone',
      value: '(512) 848-1316'
    },
    {
      label: 'Email',
      value: 'moreno@gtxinspections.com'
    },
    {
      label: 'Hours',
      value: 'Mon-Fri and Sunday, 8:00 am - 8:00 pm'
    },
    {
      label: 'Service area',
      value: 'Georgetown and Central Texas'
    }
  ];

  requestPaths = [
    {
      label: 'Buyer',
      title: 'Option-period checkup support',
      description: 'Share the property address, option-period deadline, access notes, and any concerns from the seller disclosure or walkthrough.',
      image: 'assets/images/home-home.jpg',
      imagePosition: 'center center',
      nextStep: 'GTX aligns timing with the option period.',
      nextStepDetail: 'Kari or GTX confirms availability and access details before Roland prepares for the appointment.',
      sequence: [
        'Confirm the property and contract timing.',
        'Prepare Roland for known concerns.',
        'Coordinate report timing around the decision.'
      ],
      details: [
        'Property address and MLS access notes',
        'Option-period or contract deadline',
        'Agent contact if coordination is needed'
      ]
    },
    {
      label: 'Seller',
      title: 'Pre-listing property plan',
      description: 'Use the form to share the property address, target listing timeline, and any known areas you want documented before the home goes live.',
      image: 'assets/images/kari_and_roland_rr.jpg',
      imagePosition: 'center 42%',
      nextStep: 'GTX helps organize a pre-listing appointment.',
      nextStepDetail: 'The request gives Roland context before documenting visible conditions ahead of showings.',
      sequence: [
        'Confirm the target listing window.',
        'Note known updates or recurring concerns.',
        'Use the report to plan next conversations.'
      ],
      details: [
        'Target listing window',
        'Known updates or prior repairs',
        'Preferred contact method for follow-up'
      ]
    },
    {
      label: 'New build',
      title: 'Phase or warranty inspection plan',
      description: 'Tell GTX whether you need pre-drywall, final walkthrough, re-inspection, or 11-month warranty support.',
      image: 'assets/images/new-home-construction.jpg',
      imagePosition: 'center center',
      nextStep: 'GTX matches the inspection to the builder milestone.',
      nextStepDetail: 'Builder deadlines move quickly, so phase, access, and timing details help keep the appointment useful.',
      sequence: [
        'Name the current phase or warranty deadline.',
        'Confirm access instructions.',
        'Prepare the report for builder follow-up.'
      ],
      details: [
        'Builder deadline or walkthrough date',
        'Construction phase',
        'Access instructions for the home'
      ]
    },
    {
      label: 'Homeowner',
      title: 'Maintenance inspection plan',
      description: 'Share what prompted the request, any visible concerns, and the best timing for a maintenance-focused walk-through.',
      image: 'assets/images/inspections-exterior.jpg',
      imagePosition: 'center bottom',
      nextStep: 'GTX frames the visit around practical upkeep.',
      nextStepDetail: 'Your notes help Roland focus the walk-through on visible concerns and maintenance planning.',
      sequence: [
        'Describe the concern or maintenance goal.',
        'Send any helpful photos or notes.',
        'Use the report to prioritize upkeep.'
      ],
      details: [
        'Main concern or maintenance goal',
        'Preferred inspection window',
        'Photos or notes if available'
      ]
    }
  ];

  selectRequest(index: number): void {
    this.selectedRequestIndex = index;
  }

  get selectedRequest() {
    return this.requestPaths[this.selectedRequestIndex];
  }

  fieldJournalImage(image: string): string {
    return this.fieldJournalImageMap[image] || image;
  }

}
